module.exports = __webpack_public_path__ + "img/car-icon.44de7540.svg";